module.exports = __webpack_public_path__ + "img/chart_split_bar.2c655b28.webp";